import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f076ea4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "package-bg" }
const _hoisted_2 = {
  key: 0,
  class: "active-icon"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "monetary-unit"
}

import i18n from "@/lang";
import store from "@/store";
import { computed, ref, watchEffect } from "vue-demi";

export default /*#__PURE__*/_defineComponent({
  __name: 'Package',
  props: {
  packageList: {
    type: Array,
    default: [],
  },
},
  setup(__props) {

const props = __props

const isMobile = store.state.isMobile;

const activeNumber = computed(() => store.state.pay.price);
const defaultPackageParamsArray = [
  "device_month",
  "device_month_10_49",
  "device_month_50",
];

const packages = ref([]);
watchEffect(() => {
  if (Array.isArray(props.packageList) && props.packageList.length) {
    packages.value = defaultPackageParamsArray.map((text, i) => {
      return Object.assign(
        {
          purchasePrice: i18n.global.t(`user_center.${text}`),
        },
        props.packageList[i]
      );
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packages.value, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["item", { active: _unref(activeNumber) === item.price && _unref(isMobile) }]),
        key: i + 'package'
      }, [
        (_unref(isMobile))
          ? (_openBlock(), _createElementBlock("i", _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "purchase-price",
          innerHTML: item.purchasePrice
        }, null, 8, _hoisted_3),
        _createElementVNode("div", {
          class: _normalizeClass(["price", { major: item.price === 199 }])
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("user_center.money")), 1),
          _createElementVNode("b", null, _toDisplayString(item.price), 1),
          (_unref(isMobile))
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (" + _toDisplayString(_ctx.$t("information.device_months")) + ") ", 1))
            : _createCommentVNode("", true)
        ], 2),
        (!_unref(isMobile))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("user_center.device_months")), 1)
            ]))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}
}

})